import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
const yesItems = ['Sos carpintero, armador o dueño de taller de aluminio', 'Querés dejar de calcular descuentos de cabeza y trabajar con tablas', 'Tenés ayudante y querés que pueda fabricar sin preguntarte todo', 'Querés presupuestar con margen real y dejar de regalar trabajos'];
const noItems = ['Buscás un curso teórico de carpintería metálica desde cero absoluto', 'No te interesa documentar ni sistematizar tu trabajo', 'Querés un software CAD para diseñar aberturas custom'];
export function IsForYou() {
  return <section className="py-12 bg-background border-t border-white/5" aria-label="¿Es para vos?" data-id="element-151">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-152">
        <FadeIn data-id="element-153">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-8" data-id="element-154">
            ¿ESTE SISTEMA ES PARA <span className="text-gold" data-id="element-155">VOS</span>?
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-156">
          <FadeIn delay={0.1} data-id="element-157">
            <div className="bg-surfaceLight rounded-2xl p-8 border border-emerald-500/20 h-full" data-id="element-158">
              <div className="flex items-center gap-3 mb-6" data-id="element-159">
                <span className="text-2xl" data-id="element-160">✅</span>
                <h3 className="text-xl font-bold text-emerald-400" data-id="element-161">
                  Este sistema es para vos si...
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-162">
                {yesItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-163">
                    <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-164" />
                    <span className="text-gray-200" data-id="element-165">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-166">
            <div className="bg-surfaceLight rounded-2xl p-8 border border-red-500/20 h-full" data-id="element-167">
              <div className="flex items-center gap-3 mb-6" data-id="element-168">
                <span className="text-2xl" data-id="element-169">❌</span>
                <h3 className="text-xl font-bold text-red-400" data-id="element-170">
                  Este sistema NO es para vos si...
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-171">
                {noItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-172">
                    <XCircle className="w-5 h-5 text-red-400 shrink-0 mt-0.5" data-id="element-173" />
                    <span className="text-gray-300" data-id="element-174">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}